export default __webpack_public_path__ + "static/media/religion.f41d48b1.png";